const aiPartner = [{
  desc: 'AI合伙人-工单查询(取商户管理员登录链接)',
  options: {
    url: '/qidian/queryWorkOrder',
    method: 'post',
    baseURL: '/insapi/v3/admin'
  }
}, {
  desc: 'AI合伙人-新增工单(由后端生成全新的管理员登录链接)',
  options: {
    url: '/qidian/addWorkOrder',
    method: 'post',
    baseURL: '/insapi/v3/admin'
  }
}]

export default aiPartner



// WEBPACK FOOTER //
// ./src/api/aiPartner.js